import { useCopyToClipboard } from '@/lib/hooks'
import s from '@/shared/components/CopyOverlay.module.css'

interface CopyOverlayProps {
  /** Text written to the clipboard on click. */
  value: string
  /** Accessible label (also the tooltip). Defaults to "Copy". */
  label?: string
  /** Vertically centre over a single-line input instead of top-pinning. */
  centerY?: boolean
}

/** A small ghost copy button overlaid on the top-right of a code/token box.
 *  The parent must be `position: relative`. Shows a ✓ tick on copy. */
export function CopyOverlay({ value, label = 'Copy', centerY }: CopyOverlayProps) {
  const { copy, copied } = useCopyToClipboard()
  return (
    <button
      type="button"
      className={`${s.copyOverlay}${centerY ? ` ${s.centerY}` : ''}`}
      onClick={() => copy(value)}
      aria-label={copied ? 'Copied' : label}
      title={copied ? 'Copied' : label}
    >
      {copied ? (
        <span className={s.copyTick}>✓</span>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      )}
    </button>
  )
}
